import { useDispatch, useSelector } from "react-redux";

import { Container, IconButton, Paper } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";

import { ArrowLeft, ArrowRight } from "@mui/icons-material";

import { selectOptions, setShowSidePanel } from "../../reducers/optionsSlice";
import { FBASettings } from "./FBASettings";
import { selectUser } from "../../reducers/userSlice";


const useStyles = makeStyles(theme => ({
  root: {
    border: 0,
    height: '100vh',
    padding: 0,
    marginTop: 20,
    overflow: 'hidden',
    flexBasis: 300,
    flexShrink: 0,
    flexGrow: 0
  },
  collapser: {
    width: 0,
    height: '100%',
    borderRadius: 15,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  collapseIcon: {
    width: 30,
    height: 30,
    lineHeight: '8px',
    borderRadius: 15,
    zIndex: 8,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hidden: {
    display: 'none'
  }
}));

export const FBASidePanel = ({ fbaSettings, setFbaSettings, fbaUnits, setFBAUnits }) => {

  const theme = useTheme();
  const classes = useStyles();
  const user = useSelector(selectUser);
  const options = useSelector(selectOptions);
  const dispatch = useDispatch();

  const darkMode = user?.value?.darkMode;

  return (
    <>
      {options.showSidePanel &&
      <Container className={classes.root} style={{
        backgroundColor: theme?.palette?.paper?.[darkMode ? 'dark' : 'light'],
        borderRight: `1px solid ${darkMode ? 'grey' : 'lightgrey'}`,
      }}>

        <FBASettings fbaSettings={fbaSettings} setFbaSettings={setFbaSettings} fbaTabItem={options?.fbaTabItem} fbaUnits={fbaUnits} setFBAUnits={setFBAUnits} darkMode={darkMode} />

      </Container>}
      {options?.fbaTabItem !== 5 && 
      <div className={classes.collapser} onClick={handleExpand}>
        <Paper className={classes.collapseIcon} elevation={3} style={{width: 30, height: 30, zIndex: 420}}>
          <IconButton
            size="small"
            onClick={handleExpand}
            color={darkMode ? "inherit" : "primary"}
            style={{width: 30, height: 30, backgroundColor: darkMode ? theme?.palette?.elevationTwo?.dark : theme?.palette?.elevationOne?.light}}
          >
            {options.showSidePanel ? <ArrowLeft style={{fontSize: 24}}/> : <ArrowRight style={{fontSize: 24}}/>}
          </IconButton>
        </Paper>
      </div>}
    </>
  );
 
  function handleExpand() {
    dispatch(setShowSidePanel(!options.showSidePanel));
  };

};